import React from "react";
import PageHero from "../components/PageHero";
import Lake from "../images/Sa Pa - Lake.jpg";
import "./pages.css";
import "./OurStory.css";

const timeline = [
    {
        date: "Christmas Eve, 2018",
        title: "The First Meeting",
        body: "It started with a mango float. Mac showed up on Christmas Eve and handed Kyla a homemade dessert — a small, sweet gesture that neither of them would forget. She offered him a juice drink in return, and in that brief, unassuming exchange, something quietly began.",
    },
    {
        date: "December 2018",
        title: "Getting to Know Each Other",
        body: "Before they ever met in person, Mac found Kyla on Facebook and sent her a friend request — which she accepted. The first message that really caught her attention? Mac letting her know that Miss Universe was live. That one notification sparked a conversation, and the rest followed naturally. The Christmas Eve mango float came after — their very first time meeting face to face.",
    },
    {
        date: "April 17, 2019",
        title: "Started Dating",
        body: "On April 17, 2019, they made it official. Seven years later, that date still means everything — a quiet reminder of where it all began and how far they've come together.",
    },
    {
        date: "October 12, 2025",
        title: "The Proposal",
        body: "The night before Kyla's birthday, Mac gathered the people who matter most — his family and her closest friends — at Hummingbird Cafe & Bar in Koronadal City. He got down on one knee, and she said yes. It was the best early birthday gift she'd ever received.",
    },
    {
        date: "The Aurora Film & DraKen Photo, 2026",
        title: "Prenup in Vietnam",
        body: "From the cool mountain mist of Sa Pa to the golden lantern light of Hanoi's Old Quarter, they spent five days capturing the feeling of forever. Every photo from those streets and hillsides tells the same story — two people completely at home with each other.",
    },
    {
        date: "April 25, 2026",
        title: "Getting Married",
        body: "After seven years of choosing each other, Mac and Kyla are getting married at Padre Pio Chapel, General Santos City. What started with a mango float on Christmas Eve ends here — at the altar, surrounded by everyone they love.",
    },
];

const OurStory = () => (
    <div className="page" style={{ backgroundImage: `linear-gradient(rgba(22,23,25,0.6), rgba(22,23,25,0.6)), url(${Lake})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'scroll' }}>
        <PageHero title="Our Story" image={Lake} />
        <div className="page-inner">
            <div className="timeline">
                {timeline.map((item, index) => (
                    <div key={index} className="timeline-item">
                        <div className="timeline-year">{item.date}</div>
                        <div className="timeline-content">
                            <h3 className="timeline-title">{item.title}</h3>
                            <p className="timeline-body">{item.body}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default OurStory;
